window.portalModule.factory 'SocialHistoryService', ($rootScope, $log, Restangular, AuthService, CacheFactory) ->
  $log = $log.getInstance('SocialHistoryService')

  # create a cache
  socialHistoryCache = CacheFactory('socialHistoryCache', {
    deleteOnExpire: 'aggressive',
    cacheFlushInterval: 1800000, # this cache will check for expired items 30 minutes
    storageMode: 'memory'
  })

  restAngular = Restangular.withConfig (Configurer) ->
    # configure the Restangular object here
    Configurer.setBaseUrl(AuthService.getConfigData().CLINICAL_ENDPOINT_URL)
    Configurer.setDefaultHttpFields({cache: socialHistoryCache})

  _socialHistoryService = restAngular.all("")

  find: ->
    return _socialHistoryService.customGET('social_history', {patient_practice_guid: $rootScope.DS.getCurrentPatientPracticeGuid()})